import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowWallRight"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4V20H20.5V4H22ZM13 6.68934L18.3107 12L13 17.3107L11.9393 16.25L15.4393 12.75H2V11.25H15.4393L11.9393 7.75L13 6.68934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWallRight;
